import React, { useRef, FC, useState } from 'react';
//import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

import logo from './logo.svg';
import './App.css';

import { DefaultProvider, sha256, toHex, PubKey, bsv, TestWallet, Tx, toByteString } from "scrypt-ts";
import { Helloworld02 } from "./contracts/helloworld02";

import Home from './Home';
import Home00WeBSVmenu from './Home00WeBSVmenu';
import Home01pw2pvtkey from './Home01pw2pvtkey';
import Page01TX from './Page01TX';
import Page03Read from './Page03Read';
import Page12TokenDCreate from './Page12TokenDCreate';


const provider = new DefaultProvider({network: bsv.Networks.testnet});
let Alice: TestWallet
let signerExt: TestWallet
const privateKey = bsv.PrivateKey.fromHex("79342a4c317817a80a298fe116147a74e4e90912a4f321e588a4db67204e29b0", bsv.Networks.testnet)   

function App() {
//const App: FC = () => {  

//const [currentPage, setCurrentPage] = useState<string>('home');

//const handlePageChange = (page: string) => {
//  setCurrentPage(page);
//};

  const [currentPage, setCurrentPage] = useState<string>('home00WeBSVmenu');
  const [showHomeDropdown, setShowHomeDropdown] = useState<boolean>(false);
  const [showTodoDropdown, setShowTodoDropdown] = useState<boolean>(false);
  const [showDataDropdown, setShowDataDropdown] = useState<boolean>(false);





  const handlePageChange = (page: string) => {
    setCurrentPage(page);
    setShowHomeDropdown(false);

    setShowTodoDropdown(false);
    setShowDataDropdown(false);
  };


  const handleButtonClick = (urlStr: string) => {
    // Define the site URL you want to navigate to
    let siteUrl = 'https://medium.com/@cktcracker/general-purpose-token-gptoken-6e4a06c3f01e'; // Replace with your desired site URL

    if(urlStr === 'GPToken00')
    {
      siteUrl = 'https://medium.com/@cktcracker/general-purpose-token-gptoken-6e4a06c3f01e'; // Replace with your desired site URL

    }
  
    // Open the site in a new tab or window
    window.open(siteUrl, '_blank');
  };

  const deploy = async (amount: any) => {

    Alice = new TestWallet(privateKey, provider)

    try {

      const signer = Alice
      const message = toByteString('hello world', true)
      const instance = new Helloworld02(sha256(message))
      //const instance = new Helloworld02(0n)
      
      await instance.connect(signer);
          
      const deployTx = await instance.deploy(100)
      console.log('Helloworld contract deployed: ', deployTx.id)
      alert('deployed: ' + deployTx.id)

    } catch (e) {
      console.error('deploy HelloWorld failes', e)
      alert('deploy HelloWorld failes')
    }
  };


  const interact = async (amount: any) => {

    Alice = new TestWallet(privateKey, provider)

    try {

      const signer = Alice
      const message = toByteString('hello world', true)
      let tx = new bsv.Transaction
      tx = await provider.getTransaction(txid.current.value)
  
      console.log('Current State TXID: ', tx.id)

      const instance = Helloworld02.fromTx(tx, 0) 
      await instance.connect(signer)
  
      const { tx: callTx } = await instance.methods.unlock(message)
      console.log('Helloworld contract `unlock` called: ', callTx.id)
      alert('unlock: ' + callTx.id)
  
    } catch (e) {
      console.error('deploy HelloWorld failes', e)
      alert('deploy HelloWorld failes')
    }
  };

  const txid = useRef<any>(null);

  return (


        <div className="App">

            <nav className="navbar">
              <div className="dropdown">
                <button className="button" 
                    onClick={() => {setShowHomeDropdown(!showHomeDropdown); 
                                    setShowTodoDropdown(false); setShowDataDropdown(false)}}>
                  Home
                </button>
                {showHomeDropdown && (
                  <div className="dropdown-content">

                    <button className="dropdown-button" onClick={() => handlePageChange('home')}>
                      Access
                    </button>

                    <button className="dropdown-button" onClick={() => handlePageChange('home01PvtKey')}>
                      New PvtKey
                    </button>

                    <button className="dropdown-button" onClick={() => handlePageChange('home00WeBSVmenu')}>
                      Reception
                    </button>


                  </div>
                )}
              </div>

              <div className="dropdown">
                <button className="button" 
                    onClick={() => {setShowTodoDropdown(!showTodoDropdown); 
                                    setShowHomeDropdown(false); }}>
                  Time Stamp
                </button>
                {showTodoDropdown && (
                  <div className="dropdown-content">

                    <button className="dropdown-button" onClick={() => handlePageChange('home13')}>
                      Stamp
                    </button>

                    <button className="dropdown-button" onClick={() => handlePageChange('home04')}>
                      Check
                    </button>
                    
                  </div>
                )}
              </div>


            </nav>

            {currentPage === 'home' && <Home />}
            {currentPage === 'home00WeBSVmenu' && <Home00WeBSVmenu />}

            {currentPage === 'home01PvtKey' && <Home01pw2pvtkey />}

            {currentPage === 'home02' && <Page01TX />}
            {currentPage === 'home04' && <Page03Read passedData={''}/>}
            {currentPage === 'home13' && <Page12TokenDCreate passedData={'Drop'}/>}

        </div>

 

  );
}

export default App;
